import React from 'react'
import './alert.css'
class ReturnGetAlert extends React.Component{
	constructor(props){
		super(props)
	}
	render(){
		return(
			<div className="return-role-notice">

				<span className="return-role-title">光明勇士回归称号领取规则：</span>
				
				<span>1、账号领取条件，同满足以下3个条件，即可领取专属光明勇士回归礼包；</span>
				<ul>
					    <li>1）心享俱乐部黄金及黄金以上会员；</li>
					
						<li>2）超过14天未登录光明勇士游戏；</li> 

						<li>3）当年回归登录光明勇士游戏。 </li>

				</ul>
				
				<span className="return-role-title">光明勇士充值礼包领取规则：</span>
			

				<span>1、账号领取条件，同满足以下3个条件，即可领取专属光明勇士回归充值礼包</span>

				<ul>
					    <li>1）心享俱乐部黄金及黄金以上会员；</li>
					
						<li>2） 当年回归登录光明勇士游戏；</li> 

						<li>3） 回归后消耗达到指定消耗金额，累计充值达到1元，200元、500元、1000元、2500元、5000元、12888元时，可领取对应档次的充值礼包。</li>
						<li>4） 同一认证手机只可领取一次，光明勇士充值礼包一年（自然年）只可领取一次。</li>
				</ul>
					<span>2、账号累计消耗计算规则：</span>
				<ul>
					    <li>1）当年账号回归日起开始计算回归后消耗，回归后累计消耗按单个账号计算；</li>
					
						<li className="re-set-weight">3）累计充值每年（自然年）年底12月31日清空，不累计至次年。</li> 

						

				</ul>
			
			</div>
			)

	}
}
export default ReturnGetAlert




// WEBPACK FOOTER //
// ./src/component/return-get-alert/alert7910.js